import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2716">
      <div className="dark" data-id="element-2717">
        <Hero data-id="element-2718" />
      </div>
      <WhyUs data-id="element-2719" />
      <ByTheNumbers data-id="element-2720" />
      <Services data-id="element-2721" />
      <HowItWorks data-id="element-2722" />
      <FAQ data-id="element-2723" />
      <Reviews data-id="element-2724" />
      <CtaBanner data-id="element-2725" />
    </main>;
}